import { AxiosError } from 'axios';
import ERROR_TYPE from './constants/error-type';
import IApiError from './interfaces/IApiError';

export default class ProcessingError extends Error {
    constructor(msg: string) {
        super(msg);
        this.name = ERROR_TYPE.PROCESSING_EXCEPTION;
    }
}

export const isProcessingError = (error: AxiosError<IApiError>) => {
    return (
        error.response?.status === 400 &&
        error.response?.data?.Errors.length > 0 &&
        error.response?.data?.Errors[0]?.Type ===
            ERROR_TYPE.PROCESSING_EXCEPTION
    );
};

export const getProcessingErrors = (
    error: AxiosError<IApiError>,
    entities: { id: string; name: string }[],
) => {
    const processingErrors: string[] = [];

    error.response?.data.Errors.forEach(err => {
        const entity = entities.find(b => b.id === err.Detail);

        if (entity) processingErrors.push(entity.name);
    });

    return processingErrors;
};
